var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import { Autocomplete, Box, Chip, IconButton, lighten, ListItemText, Popper, styled, TextField, useMediaQuery, useTheme, } from "@mui/material";
import { useEffect } from "react";
import { AUTH_FORM_ID } from "../../../../Account/BillingInformation/Authorize/AcceptHostedForm-types";
import { PaymentMethodType } from "../../../../Account/BillingInformation/Shared/types/PaymentProcessorTypes";
import { PaymentFormText } from "../PaymentForm-types";
import { usePaymentMethodField } from "./usePaymentMethodField";
export const PaymentMethodField = (props) => {
    const { giftCards, creditCards, selectedGiftCard, selectedCreditCard, disabled, isFormOpen, paymentMethodUpdate, setSelectedCard } = props;
    const theme = useTheme();
    const { options, cardSearch, setCardSearch, cardsSelected, updateSelections, updateValues } = usePaymentMethodField(props);
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    useEffect(() => {
        updateValues();
    }, [giftCards, creditCards, isFormOpen, selectedGiftCard, selectedCreditCard]);
    return (_jsx(Autocomplete, { fullWidth: true, multiple: true, disabled: disabled, inputValue: cardSearch, onInputChange: (event, newInputValue) => setCardSearch(newInputValue), renderInput: (params) => _jsx(TextField, Object.assign({}, params, { label: PaymentFormText.SELECT_PAYMENT_OPTION })), options: options, getOptionLabel: (option) => option.label, value: cardsSelected, onChange: (event, newValues) => {
            updateSelections(newValues);
        }, getOptionDisabled: (option) => {
            if (option.type === PaymentMethodType.GIFTCARD && selectedGiftCard)
                return true;
            else if (option.type === PaymentMethodType.CARD && selectedCreditCard)
                return true;
            else
                return false;
        }, groupBy: (option) => {
            if (option.type === PaymentMethodType.GIFTCARD)
                return PaymentFormText.GIFTCARD;
            else if (option.type === PaymentMethodType.CARD)
                return PaymentFormText.CREDITCARD;
            else
                return "";
        }, renderOption: (props, option) => (_jsxs("li", Object.assign({}, props, { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            } }, { children: [_jsx(ListItemText, { primary: option.label }), _jsx(IconButton, Object.assign({ onClick: (e) => {
                        e.stopPropagation();
                        if (option.creditCard) {
                            setSelectedCard(option.creditCard);
                            paymentMethodUpdate(option.creditCard.id);
                            // Because this IconButton lives inside an Autocomplete option,
                            // MUI attaches click handlers to the <li> that would normally close the Popper immediately.
                            // If we try to submit the form synchronously, the Popper unmounts before the submit completes,
                            // causing the submit to fail or open in a new tab.
                            // To avoid this, we:
                            //   - stopPropagation() to prevent the Autocomplete option from closing
                            //   - use setTimeout(() => submit(), 0) to defer the form submission to the next event loop tick
                            // This ensures the form still exists and the Accept Hosted iframe loads correctly inside the Dialog.
                            setTimeout(() => {
                                const form = document.getElementById(AUTH_FORM_ID);
                                form === null || form === void 0 ? void 0 : form.requestSubmit();
                            }, 0);
                        }
                    } }, { children: _jsx(EditIcon, { fontSize: "inherit" }) }))] }))), renderTags: (value, getTagProps) => value.map((option, index) => {
            const _a = getTagProps({ index }), { key, onDelete } = _a, tagProps = __rest(_a, ["key", "onDelete"]);
            return (_jsx(Chip, Object.assign({ label: option.label, onDelete: onDelete, deleteIcon: _jsxs(Box, Object.assign({ sx: { display: "flex", alignItems: "center" } }, { children: [_jsx(IconButton, Object.assign({ type: "submit", form: AUTH_FORM_ID, size: "small", sx: { mr: 0.5 }, onClick: (e) => {
                                e.stopPropagation();
                                if (option.creditCard) {
                                    setSelectedCard(option.creditCard);
                                    paymentMethodUpdate(option.creditCard.id);
                                }
                            } }, { children: _jsx(EditIcon, { fontSize: "inherit" }) })), _jsx(CancelIcon, { fontSize: "inherit", onClick: (e) => {
                                e.stopPropagation();
                                onDelete(e);
                            } })] })) }, tagProps), key));
        }), renderGroup: (params) => (_jsxs("li", { children: [_jsx(Box, Object.assign({ sx: {
                        position: "sticky",
                        top: `-${theme.spacing(1)}`,
                        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
                        zIndex: 1000,
                        color: theme.palette.primary.main,
                        backgroundColor: lighten(theme.palette.primary.light, 0.85),
                    } }, { children: params.group })), _jsx("ul", Object.assign({ style: { padding: 0 } }, { children: params.children }))] }, params.key)), PopperComponent: (_a) => {
            var { anchorEl } = _a, other = __rest(_a, ["anchorEl"]);
            if (isMobile) {
                return (_jsx(Popper, Object.assign({}, other, { disablePortal: true, anchorEl: anchorEl, popperOptions: {
                        placement: "top-start",
                    } })));
            }
            else {
                const anchorObj = typeof anchorEl === "function" ? anchorEl() : anchorEl;
                const maxHeight = window.innerHeight - anchorObj.getBoundingClientRect().bottom - 24;
                const StyledPopper = styled(Popper)({
                    "& .MuiAutocomplete-listbox": {
                        maxHeight: maxHeight,
                    },
                });
                return (_jsx(StyledPopper, Object.assign({}, other, { anchorEl: anchorEl, modifiers: [
                        {
                            name: "flip",
                            options: {
                                enabled: true,
                                fallbackPlacements: [],
                            },
                        },
                        {
                            name: "preventOverflow",
                            options: {
                                mainAxis: false,
                            },
                        },
                    ], popperOptions: {
                        placement: "bottom-start",
                    } })));
            }
        } }));
};
